import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import Navbar from "../../Components/Navbar";
import { Bg, Underline } from "../../Components/Styles/PageStyles";
import Table from "../../Components/Settings/Table";
import RentingStayRulesModal from "../../Components/Settings/RentingStayRulesModal";
import TenantKYCModal from "../../Components/Settings/TenantKYCModal";
import EvictionSettingsModal from "../../Components/Settings/EvictionSettingsModal";
import ManagementDetailsModal from "../../Components/Settings/ManagementDetailsModal";
import PropertySettingsModal from "../../Components/Settings/PropertySettingsModal";
import DuesPaymentSettings from "../../Components/Settings/DuesPaymentSettings";
import NotificationSettings from "../../Components/Settings/NotificationSettings";
import { useSelector } from "react-redux";
import Config from "../../Config";
import axios from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import OnboardingSettingsModal from "../../Components/Settings/OnboardingSettings";

const Settings = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [openModal, setOpenModal] = useState(null);
  const [selectedData, setSelectedData] = useState("");
  const [settingsData, setSettingsData] = useState(null);


  const [apiData, setApiData] = useState();

  const fetchFunction = async () => {
    const body = new FormData();
    // body.append("Id", id);
    return await axios.post(`${Config.apiUrl}/getsettings`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getSettingsSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) error = true;
    setApiData(res.data);
  };
  const getSettingsError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getSettingsMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSettingsSuccess,
    onError: getSettingsError,
  });

  useEffect(() => {
    getSettingsMutate();
  }, []);
  
  // ------- update management details ---------
  const editManagementDetailFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("name", values.name);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    // body.append("type", values.type);
    body.append("businessName", values.businessName);
    body.append("gstNumber", values.gstNumber);
    return await axios.post(`${Config.apiUrl}/editmanagementdetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getManagementDetailSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Rent Details successfully Updated.");
    }
  };

  const getmanagementDetailError = (res) => {};

  const { isLoading: isManagementDetailLoading, mutate: addManagementDetailMutate } =
    useMutation(editManagementDetailFunction, {
      onSuccess: getManagementDetailSuccess,
      onError: getmanagementDetailError,
    });

  // ------- update onboarding settings ---------
  const updateOnboardingSettings = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("onboardingPaymentReminder", values.onboardingPaymentReminder);
    body.append("tenantWelcomeMessage", values.tenantWelcomeMessage);
    body.append("tenantProfileLock", values.tenantProfileLock);
    body.append("enableKYC", values.enableKYC);
    body.append("kycMandatory", values.kycMandatory);
    return await axios.post(`${Config.apiUrl}/onboardsettings`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUpdateOnboardingSuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      getSettingsMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
  };

  const onEditOnboardingError = (data) => {
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: onboardLoading, mutate: onboardMutate } = useMutation(
    updateOnboardingSettings,
    {
      onSuccess: onUpdateOnboardingSuccess,
      onError: onEditOnboardingError,
    }
  );


  // ------- update eviction settings ---------
  const updateEvictionSettings = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("autoEviction", values.autoEviction);
    body.append("addProrateRent", values.addProrateRent);
    return await axios.post(`${Config.apiUrl}/evictionsettings`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUpdateEvictionSuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      getSettingsMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
  };

  const onEditEvictionError = (data) => {
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: evictionSettingsLoading, mutate: evictionSettingsMutate } =
    useMutation(updateEvictionSettings, {
      onSuccess: onUpdateEvictionSuccess,
      onError: onEditEvictionError,
    });

  // ------- update notification settings ---------
  const updateNotificationSettings = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("whatsApp", values.whatsApp);
    body.append("sms", values.sms);
    body.append("paymentReminder", values.paymentReminder);
    body.append("tenantOnboard", values.tenantOnboard);
    return await axios.post(`${Config.apiUrl}/notificationsettings`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUpdateNotificationSuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      getSettingsMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
  };

  const onEditNotificationError = (data) => {
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: notificationSettingsLoading,
    mutate: notificationSettingsMutate,
  } = useMutation(updateNotificationSettings, {
    onSuccess: onUpdateNotificationSuccess,
    onError: onEditNotificationError,
  });
  // Fetch Onboard settings API
  const fetchOnboardSettings = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/onboardingsettings`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  useMutation(fetchOnboardSettings, {
    onSuccess: (res) => {
      if (res?.isSuccess === true) {
        setSettingsData(res?.data);
        // setIsOpenNotiModel(true);
      }
    },
    onError: () => { },
  });
  
  // Update Onboard setting API
  const editOnboardSettings = async (values) => {
    const payload = {
      type: values.key,
      isEnabled: values.isEnabled ? 1 : 0,
    };

    return await axios.post(`${Config.apiUrl}/onboard/edit`, payload, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const { isLoading: editOnboardSettingsLoading, mutate: editOnboardSettingsMutate } =
    useMutation(editOnboardSettings, {
      onSuccess: (res) => {
        if (res?.data?.isSuccess === true) {
          toast.success(res?.data?.msg || "Settings updated successfully.");
          //fetchSettingsMutate();
        } else {
          toast.error(res?.data?.msg || "Failed to update settings.");
        }
      },
      onError: () => {
        toast.error("Error updating settings.");
      },
    });


  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{"Settings"}</Title>
              <Underline />
            </div>
          </div>

          <TableWrapper>
            <Table setOpenModal={setOpenModal} settingsData={apiData} />
          </TableWrapper>

          <div
            className={`${
              openModal ? "flex" : "hidden"
            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
            onClick={() => setOpenModal(null)}
          />

          <div
            className={`${
              openModal
                ? "translate-x-0 opacity-100"
                : "translate-x-full opacity-0"
            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
          >
            {/* {openModal === "PropertySettings" && (
              <PropertySettingsModal
                isOpen={openModal === "PropertySettings"}
                onClose={() => setOpenModal(null)}
              />
            )} */}
            {openModal === "ManagementDetails" && (
              <ManagementDetailsModal
                openModal={openModal}
                setOpenModal={setOpenModal}
                isOpen={openModal === "ManagementDetails"}
                onClose={() => setOpenModal(null)}
                settingsData={apiData?.data}
                addManagementDetailMutate={addManagementDetailMutate}
                isManagementDetailLoading={isManagementDetailLoading}
              />
            )}
            {openModal === "RentingStayRules" && (
              <RentingStayRulesModal
                openModal={openModal}
                setOpenModal={setOpenModal}
                isOpen={openModal === "RentingStayRules"}
                onClose={() => setOpenModal(null)}
              />
            )}
            {/* {openModal === "DuesPaymentSettings" && (
              <DuesPaymentSettings
                isOpen={openModal === "DuesPaymentSettings"}
                onClose={() => setOpenModal(null)}
              />
            )} */}
            {openModal === "TenantKYC" && (
              <TenantKYCModal
                isOpen={openModal === "TenantKYC"}
                onClose={() => setOpenModal(null)}
                settingsData={apiData?.data}
                tenantKYCMutate={onboardMutate}
                tenantKYCLoading={onboardLoading}
              />
            )}
            {openModal === "NotificationSettings" && (
              <NotificationSettings
                isOpen={openModal === "NotificationSettings"}
                onClose={() => setOpenModal(null)}
                settingsData={apiData?.data || {}}
                notificationMutate={notificationSettingsMutate}
                notificationLoading={notificationSettingsLoading}
                // editNotiSettingsMutate={editNotiSettingsMutate}

              />
            )}
            {openModal === "EvictionSettings" && (
              <EvictionSettingsModal
                isOpen={openModal === "EvictionSettings"}
                onClose={() => setOpenModal(null)}
                settingsData={apiData?.data}
                evictionSettingsMutate={evictionSettingsMutate}
                evictionSettingsLoading={evictionSettingsLoading}
              />
            )}
            {openModal === "OnboardingSettings" && (
              <OnboardingSettingsModal
                onClose={() => setOpenModal(null)}
                settingsData={settingsData || {}}
                // isonboardSettingsLoading={isonboardSettingsLoading}
                editOnboardSettingsMutate={editOnboardSettingsMutate}
              />
            )}
          </div>
        </BoxContainer>
      </Bg>
    </>
  );
};

const TableWrapper = tw.h1`my-10  rounded-md `;
const BoxContainer = tw.div`Container mt-2 px-6`;
const Title = tw.h1`text-2xl  text-gray-800 whitespace-nowrap  font-semibold`;

export default Settings;